import { post, put } from './requests'

export function createDocumentSending ({ documentId, date, ...restData }) {
  return post(`documents/${documentId}/sending`, { sending: restData, date })
}

export function testDocumentSending ({ documentId, ...restData }) {
  return post(`documents/${documentId}/sending/test`, { sending: restData })
}

export function sendDocumentReminder (documentId) {
  return post(`documents/${documentId}/sending/remind`)
}

export function updateDocumentSending ({ documentId, date, ...restData }) {
  return put(`documents/${documentId}/sending`, { sending: restData, date })
}
